import { Dispatch, SetStateAction } from 'react';
import { noop } from 'lodash';

import { createContext } from 'use-context-selector';

import { CardState } from './Card.types';

interface CardContextProps {
  setState: Dispatch<SetStateAction<CardState>>;
}

export const CardContext = createContext<CardContextProps>({
  setState: noop,
});
